import { render, staticRenderFns } from "./editContractTypeSpec.vue?vue&type=template&id=35490846&scoped=true"
import script from "./editContractTypeSpec.vue?vue&type=script&lang=js"
export * from "./editContractTypeSpec.vue?vue&type=script&lang=js"
import style0 from "./editContractTypeSpec.vue?vue&type=style&index=0&id=35490846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35490846",
  null
  
)

export default component.exports